<template>
  <nav class="navbar navbar-fixed-top">
    <div class="container-fluid xs-p-0">
      <!-- Logo -->
      <div class="navbar-logo">
        <router-link to="/" class="logo"><img src="/static/img/logo.png" /></router-link>
      </div>

      <div class="right-navbar">
        <LoggedInLinks v-if="currentUser.loggedIn" />
        <LoggedOutLinks v-else />
      </div>

      <div class="public-nav" v-if="page.publicNav">
        <div class="dropdown">
          <a href="#" data-toggle="dropdown" role="button" aria-expanded="false" class="dropdown-toggle">
            <div class="bar1"></div>
            <div class="bar2"></div>
            <div class="bar3"></div>
          </a>

          <ul role="menu" class="dropdown-menu nav">
            <li v-for="link in navLinks">
              <router-link :to="{name: link.routeName}">{{link.title}}</router-link>
            </li>
            <li>
              <LoggedOutLinks v-if="!currentUser.loggedIn" />
            </li>
          </ul>
          
        </div>
      </div>
    </div>
  </nav>

</template>

<script>
import { mapState } from 'vuex'
import LoggedInLinks from './LoggedInLinks'
import LoggedOutLinks from './LoggedOutLinks'

export default {
  components: {
    LoggedInLinks,
    LoggedOutLinks,
  },

  data() {
    return {
      navLinks: [
        { title: 'Features', routeName: 'features' },
        { title: 'About CLEX', routeName: 'about-us' },
        { title: 'Contact Us', routeName: 'contact-us' },
        { title: 'Advertise', routeName: 'advertise' },
        { title: 'Blog', routeName: 'blog' },
      ]
    }
  },

  computed: mapState([
    'currentUser',
    'page'
  ]),
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .navbar {background:#FFFFFF;height:100px;border-bottom: 1px solid #EEEEEE;}
  .navbar .navbar-logo { float: left; }
  .navbar .public-nav { float: left; }
  .navbar .right-navbar { float: right; position:relative;}

  .logo { padding: 30px 100px 30px 60px; display: block;height:100px; }
  .logo img {height:100%;}

  .navbar .public-nav .nav { margin: 0px 0px 0px 0px; }
  .navbar .public-nav .nav li { float: left; }
  .navbar .public-nav .nav li a { font-size: 20px; display: block; line-height: 82px; color: #191c21; font-weight:400;}
  .navbar .public-nav .nav .active, .nav .active:focus { color: #4285f4; }
  .navbar .public-nav .nav li a:hover { border-bottom: 2px solid #4285f4; background: none; color: #4285f4; }

  .app-layout .navbar { height: 60px; }
  .app-layout .logo {height:60px;padding:10px 50px 10px 20px;}

  @media (max-width: 1100px) { .logo { padding: 30px 30px 30px 30px; }
    .navbar .public-nav .dropdown-menu li a { padding: 10px 15px; font-size:16px;}
  }
  @media (max-width: 850px) {
    .logo { padding: 30px 10px 30px 20px; }
    .navbar .public-nav .dropdown-menu li a { padding: 10px 10px; }
  }

  @media (min-width: 780px) {
    .navbar .public-nav .dropdown-toggle {display:none;}
    .navbar .public-nav .dropdown-menu { position: static;display:block !important;border:0px;box-shadow:none;width:auto;padding:0px;background:none;}
    .navbar .public-nav .navbar-right { display: none; }
  }
  @media (max-width: 779px)
  {
    .navbar .public-nav {float:right;}
    .navbar .public-nav .dropdown-toggle { font-size: 30px; color: #404040; padding: 30px 6px 30px 6px; display:block;}
    .navbar .public-nav .dropdown-toggle:hover,
    .navbar .public-nav .open .dropdown-toggle{ }
    .navbar .public-nav .dropdown-menu { position: fixed; top: 100px;width:100%;padding:0px;left:0%;border:0px;}
      .navbar .public-nav .dropdown-menu li { float: none; background: #4285f4 ;}
    .navbar .navbar-right.navbar-nav { display: none; }
    .navbar .public-nav .navbar-right { display: block; }
    .navbar .public-nav .nav li a {line-height:40px;color:#FFFFFF;border-bottom:1px solid #FFFFFF;text-align:center;}

      .navbar .public-nav .nav li a.active { color: #4285f4; background:#FFFFFF;}

    .bar1, .bar2, .bar3 { width: 35px; height: 4px; background-color: #777; margin: 7px 0; transition: 0.3s; }

    .open .bar1 { -webkit-transform: rotate(-45deg) translate(-9px, 6px); transform: rotate(-45deg) translate(-9px, 6px); }

    .open .bar2 { opacity: 0; }

    .open .bar3 { -webkit-transform: rotate(45deg) translate(-8px, -8px); transform: rotate(45deg) translate(-8px, -8px); }
  }
</style>



// WEBPACK FOOTER //
// Navbar.vue?9a76784c